import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import PrivacyPolicyPage from './pages/Mentions_legale/PrivacyPolicyPage/PrivacyPolicyPage';
import TermsOfUsePage from './pages/Mentions_legale/TermsOfUse/TermsOfUsePage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Page d'accueil */}
        <Route path="/" element={<HomePage />} />
        <Route path="/legal/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/legal/terms" element={<TermsOfUsePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
